export const urlConfig = {    
    // конфигурация для тестового сервера
    // encryption: false,
    // host: '10.10.3.77', 
    // port: 32784,

    //конфигурация для боевого сервера
    encryption: true,
    host: 'api.vega-mx.com',
    port: 443

    //конфигурация для локальной разработки
//     encryption: false,
//     host: 'localhost',
//     port: 7502
};
